export const OBS_FREQUENCY = [
  { id: 'PERIOD_END', displayValue: 'Period End' },
  { id: 'DAILY_AT_CLOSE', displayValue: 'Daily at Close' },
  { id: 'DAILY_CONTINUOUS', displayValue: 'Daily Continuous' },
];
